// extracted by mini-css-extract-plugin
export var labelWrapper = "_fr-0";